import { useState } from 'react'
import type { FC } from 'react'
import { useQuery } from '@tanstack/react-query'

import { rqKeys } from '@/react-query-keys'
import { apiRequestNew } from '@/helpers/request'
import { getMs } from '@/helpers'
import { formatTs } from '@/helpers'
import { Skeleton } from '@/components'
import type { T_NewsListRes } from '@/types/responses'
import { NewsDrawer } from '../news-drawer'
import { NewsArticleDrawer } from '../news-article-drawer'
import {
  SC_NewsListWrapper,
  SC_NewsItem,
  SC_NewsDate,
  SC_NewsTitle,
} from '../news-drawer/styled'
import { SC_RoundedCard } from '../../../styled'
import iconArrowRightSvg from '../../../img/icon-arrow-right.svg'
import { SC_GoToAllNews } from './styled'


export const NewsWidget: FC = () => {
  const [ isNewsDrawerVisible, setIsNewsDrawerVisible ] = useState<boolean>(false)
  const showNewsDrawer = () => setIsNewsDrawerVisible(true)
  const hideNewsDrawer = () => setIsNewsDrawerVisible(false)

  const [ selectedArticle, setSelectedArticle ] = useState<string | null>(null)

  const {
    data: newsList,
    isPending: isNewsListPending,
  } = useQuery<T_NewsListRes>({
    queryKey: [ rqKeys.newsList ],
    queryFn: () => apiRequestNew(
      'GET',
      '/portal/article?lang=47&path=information%2Fnews&visitor_group=1%2C2&order=timed&offset=0&limit=3'
    ),
    staleTime: getMs('15m'),
    refetchOnWindowFocus: false,
  })


  return (
    <SC_RoundedCard>
      <SC_GoToAllNews onClick={showNewsDrawer}>
        <span>Новости</span>
        <img src={iconArrowRightSvg} />
      </SC_GoToAllNews>

      <SC_NewsListWrapper>
        {isNewsListPending ? (
          <Skeleton count={3} />
        ) : (
          (newsList || []).map((item) => (
            <SC_NewsItem key={item.id} onClick={() => setSelectedArticle(item.name)}>
              <SC_NewsDate>{formatTs(item.time)}</SC_NewsDate>
              <SC_NewsTitle>{item.title.ru}</SC_NewsTitle>
            </SC_NewsItem>
          ))
        )}
      </SC_NewsListWrapper>

      {isNewsDrawerVisible && (
        <NewsDrawer
          hideNewsDrawer={hideNewsDrawer}
        />
      )}

      {selectedArticle && (
        <NewsArticleDrawer
          articleName={selectedArticle}
          onClose={() => setSelectedArticle(null)}
        />
      )}
    </SC_RoundedCard>
  )
}
